import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, styled } from '@mui/material';
import ModalContent from '@/components/modals/ModalContent';

const Container = styled(Box)(() => ({
  height: '100dvh',
  display: 'flex',
  justifyContent: 'center',
}));

const ShareLayout: FC = () => {
  return (
    <Container>
      <ModalContent />
      <Outlet />
    </Container>
  );
};

export default ShareLayout;
